import { render, staticRenderFns } from "./SwitchTable.vue?vue&type=template&id=3e07ec9e&"
import script from "./SwitchTable.vue?vue&type=script&lang=js&"
export * from "./SwitchTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports